module.exports = __webpack_public_path__ + "img/材料力学1_5_1.f6474eae.jpg";